import { usePage } from '@inertiajs/react'

import type { GlobalPageProps } from 'helpers/interfaces'

export function useFeatures() {
  return usePage<GlobalPageProps>().props.features ?? {}
}
